import React from 'react';
import { useIntl } from 'react-intl';

import { SxProps } from '@mui/material/styles';
import TextField from '@mui/material/TextField';

interface FillInTheBlanksQuestionPreviewProps {
  sx?: SxProps;
  text: string;

  error?: string;
}

const FillInTheBlanksQuestionPreview = (props: FillInTheBlanksQuestionPreviewProps) => {
  const { sx, error, text } = props;
  const intl = useIntl();

  return (
    <TextField
      sx={sx}
      error={!!error}
      label={intl.formatMessage({ id: 'preview' })}
      variant="standard"
      helperText={error}
      value={text}
      disabled
      multiline
      minRows={1}
      maxRows={10}
    />
  );
};

export default FillInTheBlanksQuestionPreview;
